import { isEmpty } from "@s-libs/micro-dash";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useFormativeWebTokenGet = (
  {
    contentId,
    formativeDestination,
    quizId,
    rawLexile,
    formativeAttachmentId,
    useOAuth,
  },
  skip = false,
) => {
  let resource = `${MONOLITH_ORIGIN}/apps/formative/jwt/${contentId}/`;
  const params = {
    ...(formativeDestination && { formativeDestination }),
    ...(quizId && { quizContentId: quizId }),
    ...(rawLexile && { rawLexile }),
    ...(formativeAttachmentId && { formativeAttachmentId }),
    ...(useOAuth && { useOAuth }),
  };

  if (!isEmpty(params)) {
    const queryString = new URLSearchParams(params).toString();
    resource = `${resource}?${queryString}`;
  }

  return useRestQuery(resource, { skip: !contentId || skip });
};

export default useFormativeWebTokenGet;
